// Comunes a todas las pantallas del admin y del portal: select2 dentro de modales y los componentes de formulario
// x-form.select2 / x-form.input-date, que llevan su configuración en atributos data-* (sin JS en las vistas).
// Token CSRF para las llamadas AJAX (meta csrf-token del layout).
window.csrfToken = () => document.querySelector('meta[name="csrf-token"]')?.getAttribute('content') || ''

// Opciones de la pantalla (rutas, permisos, textos): la vista las deja en <script type="application/json" id="pageOptions">
// y el JS de la pantalla las lee como window.options (se leen al primer uso).
if (!Object.prototype.hasOwnProperty.call(window, 'options')) {
  Object.defineProperty(window, 'options', {
    configurable: true,
    get() {
      const el = document.getElementById('pageOptions')
      const value = el ? JSON.parse(el.textContent) : undefined
      if (el) Object.defineProperty(window, 'options', { value, writable: true, configurable: true })
      return value
    }
  })
}

;(function ($) {
  /* ---------------------------------------------------------------------------
   | select2 dentro de un modal: si no se indica dropdownParent, el desplegable se monta en <body> y el modal de
   | Bootstrap le quita el foco (no se puede escribir ni hacer clic). Se engancha al modal automáticamente y se enfoca
   | el buscador al abrir.
   * ------------------------------------------------------------------------- */
  if ($.fn.select2) {
    const originalSelect2 = $.fn.select2
    $.fn.select2 = function (options) {
      // El componente x-form.select2 manda su config vacía como [] (array), por eso se acepta también.
      if (options === undefined || $.isPlainObject(options) || Array.isArray(options)) {
        return this.each(function () {
          const $modal = $(this).closest('.modal')
          const config = Array.isArray(options) ? {} : $.extend({}, options)
          if ($modal.length && !config.dropdownParent) config.dropdownParent = $modal
          originalSelect2.call($(this), config)
        })
      }
      return originalSelect2.apply(this, arguments)
    }
    $.extend($.fn.select2, originalSelect2)

    $(document).on('select2:open', function (e) {
      const instance = $(e.target).data('select2')
      if (instance && !instance.options.get('multiple')) {
        setTimeout(() => instance.$dropdown.find('.select2-search__field').get(0)?.focus(), 0)
      }
    })
  }

  /** Config de PHP para flatpickr: los valores "js:..." son código (p. ej. funciones de fecha). */
  function parseDateConfig(cfg) {
    for (const prop in cfg) {
      const value = cfg[prop]
      if (typeof value === 'string' && value.startsWith('js:')) {
        // eslint-disable-next-line no-eval
        cfg[prop] = eval(value.slice(3))
      } else if (value && typeof value === 'object') {
        cfg[prop] = parseDateConfig(value)
      }
    }
    return cfg
  }

  $(function () {
    // x-form.select2: data-select2-config = config; data-select2-old-values = valores enviados si hubo errores de
    // validación. (No se usa data-select2: select2 guarda ahí su instancia.)
    $('select[data-select2-config]').each(function () {
      const $select = $(this)
      $select.select2(JSON.parse(this.getAttribute('data-select2-config') || '{}'))
      const old = JSON.parse(this.getAttribute('data-select2-old-values') || 'null')
      if (Array.isArray(old)) {
        $select.find('option').each(function () {
          const value = $(this).val() || $(this).text()
          $(this).prop('selected', old.map(String).includes(String(value)))
        })
        $select.trigger('change')
      }
    })

    // x-form.input-date: data-flatpickr-config = config; data-flatpickr-initial = valor inicial (o el enviado).
    $('input[data-flatpickr-config]').each(function () {
      const input = this
      $(input).flatpickr(parseDateConfig(JSON.parse(input.getAttribute('data-flatpickr-config') || '{}')))
      $(input)
        .siblings('[data-toggle]')
        .css('cursor', 'pointer')
        .on('click', () => input._flatpickr.open())
      // attr (no .data): el valor va tal cual, sin que jQuery lo convierta a número.
      $(input).val(input.getAttribute('data-flatpickr-initial') || '')
    })
  })
})(jQuery)
